"use client";

import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import React from "react";
import { StorageSortBy, storageSortByOptions } from "../../../../types";
import { useStorageQuery } from "../../../../hooks/storageQueryProvider";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function SortBy() {
    const { dir } = useLocale();
    const { foldersQuery, updateFoldersQuery } = useStorageQuery();
    const sortByOption = storageSortByOptions.find(
        (o) => o.value === foldersQuery.sortBy
    );

    return (
        <DropdownMenu dir={dir}>
            <DropdownMenuTrigger asChild>
                <Button
                    className="gap-1 font-normal text-sm"
                    variant="outline"
                    size="sm"
                >
                    {t("storage.folders-grid.sort-btn", undefined, undefined)}
                    : {t(sortByOption!.keyName, undefined, undefined)}
                    <ChevronDown className="size-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent side="bottom" align="end" className="w-40">
                <DropdownMenuRadioGroup
                    value={foldersQuery.sortBy}
                    onValueChange={(value: string) => {
                        updateFoldersQuery({
                            sortBy: value as StorageSortBy,
                            page: 1,
                        });
                    }}
                >
                    {storageSortByOptions.map((option) => (
                        <DropdownMenuRadioItem
                            key={option.value}
                            value={option.value}
                            className="text-sm"
                        >
                            {t(option.keyName, undefined, undefined)}
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
